export interface SortFilterOption<T extends string> {
  value: T
  label: string
  enabled: boolean
}

export interface ProductionSortFilterType {
  sortOption: SortFilterOption<server.dto.ProductionSort>
}

export const DefaultProductionSortFilter: server.dto.ProductionSort = "date_asc";

export const ProductionSortOptions: Array<SortFilterOption<server.dto.ProductionSort>> = [
  {
    label: RESX.DateTime.lblDate,
    value: "date_asc",
    enabled: true
  },
  {
    label: RESX.GeneralLabels.Name,
    value: "name_asc",
    enabled: true
  }
];

export const getSortOption = (value: server.dto.ProductionSort) => {
  return ProductionSortOptions.find(s => s.value === value);
};

export const initialProductionSortFilter: ProductionSortFilterType = {
  sortOption: getSortOption(DefaultProductionSortFilter)
};
